import { render, staticRenderFns } from "./comuser_dashboard.vue?vue&type=template&id=2154274c&"
import script from "./comuser_dashboard.vue?vue&type=script&lang=js&"
export * from "./comuser_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./comuser_dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports